import { render } from "./MoveBody.vue?vue&type=template&id=e2f6f940&scoped=true&ts=true"
import script from "./MoveBody.vue?vue&type=script&lang=ts"
export * from "./MoveBody.vue?vue&type=script&lang=ts"

import "./MoveBody.vue?vue&type=style&index=0&id=e2f6f940&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f6f940"]])

export default __exports__